import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './hooks/useTheme';
import Header from './components/Header';
import Home from './components/Home';
import AnnuityCalculator from './components/AnnuityCalculator';
import LinearCalculator from './components/LinearCalculator';
import InterestRatePlots from './components/InterestRatePlots';
import ContactForm from './components/ContactForm';
import './App.css';

const App: React.FC = () => {
  return (
    <ThemeProvider>
      <Router>
        <div className="App">
          <Header />
          <main className="container">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/annuity-calculator" element={<AnnuityCalculator />} />
              <Route path="/linear-calculator" element={<LinearCalculator />} />
              <Route path="/interest-rates" element={<InterestRatePlots />} />
              <Route path="/contact" element={<ContactForm />} />
              {/*<Route path="/calculator" element={<Navigate to="/annuity-calculator" replace />} />*/}
              {/*<Route path="*" element={<Navigate to="/" replace />} />*/}
            </Routes>
          </main>
        </div>
      </Router>
    </ThemeProvider>
  );
};

export default App;
